package com.neurobs.js.dom

import java.time.Instant

import com.neurobs.util.SecondsTimestamp
import scalatags.JsDom.all._
import org.scalajs.dom.html.Span

object StopWatchElement {
	/**
	  * @param start Beginning time
	  * @param end End time
	  * @return time difference with format h:mm:ss
	  */
	def formatDifference(start: SecondsTimestamp, end: SecondsTimestamp): String = {
		def forceTwoDigits(i: Long): String = if (i < 10) "0" + i.toString else i.toString
		val seconds = end.instant.getEpochSecond - start.instant.getEpochSecond
		val minutes = seconds / 60;
		val hours = minutes / 60
		if (hours == 0) minutes.toString + ":" + forceTwoDigits(seconds % 60)
		else hours.toString + ":" + forceTwoDigits(minutes % 60) + ":" + forceTwoDigits(seconds % 60)
	}

	/** Element displaying times since a start time which updates itself
	  * every second
	  *
	  * @note The updating is stopped if the element is not in the global dom tree.
	  *       You have 1 second to get this into the dom after creating it.
	  *
	  * @param startTime Start time for time difference
	  * @param styleClass CCS style class for the element
	  * @return HTML span element
	  */
	def make(startTime: SecondsTimestamp, styleClass: Option[String] = None): Span = {
		val container = span().render
		styleClass.foreach(c => container.className = c)

		def update(): Boolean = {
			container.innerHTML = formatDifference(startTime, SecondsTimestamp.now())
			true
		}

		container.id = Timer.createRecurringElementTimer(intervalMs = 1000)(update)
		update()

		container
	}
}
